define(function (require, exports, module) {
    'use strict';

    var hasNativeNormalize = /\[native code\]/.test(String.prototype.normalize);

    /**
     * @returns {string}
     */
    function normalizeToNfc(string) {
        var result;

        if (hasNativeNormalize) {
            result = string.normalize('NFC');
        } else {
            result = string;
        }

        return result;
    }

    module.exports = normalizeToNfc;
});
